// components/PremiumActionGuard/index.js
import React, { useState } from 'react';

import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import Modal from 'components/Modal/Modal';

const PremiumActionGuard = ({
  hasAccess,
  children,
  modalTitle = 'Premium Feature',
  modalDescription = 'This feature is available with a Premium membership.',
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleClickCapture = e => {
    if (!hasAccess) {
      e.preventDefault();
      e.stopPropagation();
      setIsOpen(true);
    }
  };

  return (
    <>
      {React.cloneElement(children, {
        onClickCapture: handleClickCapture,
      })}

      <Modal
        isOpen={isOpen}
        title={modalTitle}
        onRequestClose={() => setIsOpen(false)}
      >
        <div className="p-4">
          <p>{modalDescription}</p>
          <Link to="/membership-plans" className="btn btn-primary">
            Upgrade to Premium
          </Link>
        </div>
      </Modal>
    </>
  );
};

PremiumActionGuard.propTypes = {
  hasAccess: PropTypes.bool.isRequired,
  children: PropTypes.element.isRequired,
  modalTitle: PropTypes.string,
  modalDescription: PropTypes.string,
};

export default PremiumActionGuard;
